"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldLinkedField = void 0;
var flApi = require("./flApi");
var RootClass = require("./rootClass");
var FieldLinkedField = (function (_super) {
    __extends(FieldLinkedField, _super);
    function FieldLinkedField(typeObj, jSonDoc, srvType) {
        if (srvType === void 0) { srvType = 1; }
        var _this = _super.call(this, typeObj, jSonDoc, srvType) || this;
        if (typeObj !== "linkedField") {
            throw new Error("wrong objectType for a linked field");
        }
        return _this;
    }
    Object.defineProperty(FieldLinkedField.prototype, "foreignerFCNs", {
        get: function () {
            var myLF = this;
            return myLF.getRemoteFieldsFromTemplate(myLF.linkedTemplate);
        },
        set: function (newVal) {
            throw new Error("forbidden");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FieldLinkedField.prototype, "foreignerFCN", {
        get: function () {
            var myLF = this;
            return myLF.getRemoteFieldsFromTemplate(myLF.linkedTemplate)[0];
        },
        set: function (newVal) {
            throw new Error("forbidden");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FieldLinkedField.prototype, "foreignerEcn", {
        get: function () {
            var myLF = this;
            var myPt = flApi.Api.getInstance().getObject(myLF.linkedRelation[0]);
            return myPt.pointer[1].ptEcn;
        },
        set: function (newVal) {
            throw new Error("forbidden");
        },
        enumerable: false,
        configurable: true
    });
    FieldLinkedField.prototype.encode = function (jSonData) {
        return _super.prototype.encode.call(this, jSonData);
    };
    FieldLinkedField.prototype.decode = function () {
        return _super.prototype.decode.call(this);
    };
    FieldLinkedField.prototype.setProp = function (propName, value) {
        return _super.prototype.setProp.call(this, propName, value);
    };
    FieldLinkedField.prototype.save = function () {
        return _super.prototype.save.call(this, 0);
    };
    FieldLinkedField.prototype.postProcess = function () {
        _super.prototype.postProcess.call(this);
    };
    FieldLinkedField.prototype.unSubDocumentize = function () {
        throw new Error("not yet implemented");
    };
    FieldLinkedField.prototype.checkRelation = function (values, myLF) {
        var bGood = true;
        var curEcn = myLF.eCN;
        values.forEach(function (ptId) {
            if (bGood) {
                var fiPt = myLF.myApi.getObject(ptId);
                if (fiPt === null || fiPt.systemType !== "pointer") {
                    console.log("linkedField id: " + myLF.id + " pointer field id " + values.join(", ") + " not found");
                    bGood = false;
                }
                else {
                    if (fiPt.pointer[0].ptEcn !== curEcn) {
                        bGood = false;
                    }
                    curEcn = fiPt.pointer[1].ptEcn;
                }
            }
        });
        return bGood;
    };
    FieldLinkedField.prototype.getTemplateList = function (forceReload, idToLimits) {
        if (forceReload === void 0) { forceReload = false; }
        if (idToLimits === void 0) { idToLimits = []; }
        return this.myApi.restApi.loadTemplateList(this.myECN, this.id, idToLimits);
    };
    FieldLinkedField.prototype.changeToStringField = function (strUiType) {
        if (strUiType === void 0) { strUiType = "text"; }
        return this.dePromote(strUiType, "string");
    };
    FieldLinkedField.prototype.changeToNumberField = function () {
        return this.dePromote("number", "number");
    };
    FieldLinkedField.prototype.delete = function (options) {
        if (options === void 0) { options = ""; }
        if (options.indexOf("cascade") === -1) {
            var cascad = (this.toClass()).uiType === "linkedField" ? true : false;
            options += (options.length === 0) ? "cascade=" + cascad : "&cascade=" + cascad;
        }
        if (this.toClass().uiType === "lookup" && options.indexOf("cascade=true") !== -1) {
            throw new Error("cannot delete cascade on lookup");
        }
        return _super.prototype.delete.call(this, options);
    };
    FieldLinkedField.prototype.deleteCascade = function (bCascade) {
        if (bCascade === void 0) { bCascade = undefined; }
        if (this.toClass().uiType === "linkedField") {
            return this.delete("cascade=" + ((bCascade || bCascade === undefined) ? "true" : "false"));
        }
        return this.delete("cascade=false");
    };
    FieldLinkedField.prototype.isFieldUsedInTemplate = function (fCN) {
        var meLF = this;
        var fields = this.getRemoteFieldsFromTemplate(meLF.linkedTemplate);
        return fields.indexOf(fCN) !== -1;
    };
    FieldLinkedField.prototype.getRemoteFieldsFromTemplate = function (template) {
        var meLF = this;
        var foreignFCNs = [];
        try {
            var tmplArr = template.split("<%=");
            tmplArr.forEach(function (anItem) {
                var last = anItem.indexOf("%");
                if (last > -1) {
                    var idx = anItem.substr(0, last).indexOf("c");
                    if (idx < 0) {
                        idx = 0;
                    }
                    var fieldCN = Number(anItem.substr(idx + 1, last - idx - 1));
                    if (!isNaN(fieldCN)) {
                        foreignFCNs.push(fieldCN);
                    }
                }
            });
            if (foreignFCNs.length === 0) {
                var fiPt = this.myApi.getObject(meLF.linkedRelation[0]);
                if (fiPt === null || fiPt.systemType !== "pointer") {
                    console.log("linkedField inconsistency: " + JSON.stringify(meLF.decode()));
                    return [];
                }
                var reEnt = this.myApi.getObject(fiPt.pointer[1].ptEcn);
                meLF.linkedTemplate = "";
                reEnt.fields.forEach(function (aFi) {
                    if (meLF.linkedTemplate === "" && aFi.systemType === "string") {
                        meLF.linkedTemplate = "<%= c" + aFi.id + " %>";
                        foreignFCNs.push(aFi.id);
                    }
                });
            }
            return foreignFCNs;
        }
        catch (err) {
            console.log(err.stack);
            console.log("invalid template: fcn: " + this.id + ", jDoc: " + JSON.stringify(this.decode()));
            return [];
        }
    };
    FieldLinkedField.prototype.getRemoteFieldFromTemplate = function (newTemplate) {
        this.getRemoteFieldsFromTemplate(newTemplate);
        return (this.foreignerFCNs.length === 0) ? -1 : this.foreignerFCNs[0];
    };
    FieldLinkedField.prototype.toClass = function () {
        return this;
    };
    FieldLinkedField.prototype.dePromote = function (strUiType, targetType) {
        if (this.toClass().uiType !== "linkedField") {
            throw new Error("only uiType linkedField can be dePromoted");
        }
        return this.myApi.restApi.dePromoteToStr(this.eCN, this.id, "strUiType=" + strUiType + "&targetType=" + targetType);
    };
    FieldLinkedField.prototype.isThereAnyConnectedFields = function (bLookToRollup) {
        var _this = this;
        if (bLookToRollup === void 0) { bLookToRollup = true; }
        var delRemote = true;
        var ptField = this.myApi.getObject(this.toClass().linkedRelation[0]);
        if (ptField === null) {
            throw new Error("linked Relation[0] is corrupted");
        }
        var myEntity = this.myApi.getObject(ptField.eCN);
        if (myEntity === null) {
            throw new Error("eCN corrupted");
        }
        myEntity.fields.forEach(function (aFi) {
            if (aFi.systemType === "linkedField") {
                if (aFi.linkedRelation[0] === ptField.id && _this.id !== aFi.id) {
                    if (delRemote) {
                        console.error("not deleting the pointer, because linkedRelation " + aFi.id + " is using it");
                    }
                    delRemote = false;
                }
            }
            if (aFi.systemType === "rollup" && bLookToRollup) {
                aFi.rolPtDetails.forEach(function (aPtDetail) {
                    if (aPtDetail.ptId === ptField.id) {
                        if (delRemote) {
                            console.error("not deleting the pointer, because rollup " + aFi.id + " is using it");
                        }
                        delRemote = false;
                    }
                });
            }
        });
        if (bLookToRollup) {
            myEntity = this.myApi.getObject(0);
            myEntity.fields.forEach(function (aFi) {
                if (aFi.systemType === "rollup") {
                    aFi.rolPtDetails.forEach(function (aPtDetail) {
                        if (aPtDetail.ptId === ptField.id) {
                            if (delRemote) {
                                console.error("not deleting the pointer, because rollup " + aFi.id + " is using it");
                            }
                            delRemote = false;
                        }
                    });
                }
            });
        }
        return delRemote;
    };
    return FieldLinkedField;
}(RootClass.RootClass));
exports.FieldLinkedField = FieldLinkedField;
